import permissions from '../permissions'

const TRAINING_LIST = [
  {
    name: 'Antigo portal de treinamento',
    tag: permissions.MOODLE_TRAININGS.VIEW,
    description:
      'Concede acesso ao antigo portal para visualização e realização dos cursos disponíveis, incluindo também o acesso integrado ao Portal da Comunidade e à Universidade da Privacidade.',
  },
  {
    name: 'Novo portal de treinamento',
    tag: permissions.NEW_PLATFORM_COURSE.TREINING_PORTAL,
    description:
      'Concede acesso ao novo portal de treinamento para visualização e realização de cursos disponíveis.',
  },
  {
    name: 'Configurar curso (somente visualizar)',
    tag: permissions.NEW_PLATFORM_COURSE.SHOW,
    description:
      'Concede acesso em modo de leitura às telas de configuração de cursos na nova plataforma.',
  },
  {
    name: 'Configurar curso (Gerenciar)',
    tag: permissions.NEW_PLATFORM_COURSE.CONFIG,
    description:
      'Concede controle total (leitura e escrita) sobre as configurações de cursos na nova plataforma',
  },
]

export default TRAINING_LIST
